import { ArrowLeft, ArrowRight } from '@phosphor-icons/react/dist/ssr';

type ArrowIconProps = {
  direction: 'left' | 'right'
  className?: string
}

/** Phosphor's fill-weight arrow, used by the mobile pillar carousel's prev/next controls. */
export function ArrowIcon({ direction, className = 'h-4 w-4' }: ArrowIconProps) {
  const Icon = direction === 'right' ? ArrowRight : ArrowLeft
  return <Icon weight="fill" className={className} aria-hidden="true" />
}
